import React from "react";
import {useTranslation} from "react-i18next";
import CssBaseline from "@mui/material/CssBaseline";
import {NoSsr} from "@mui/material";
import MainLayout from "../../components/layout/MainLayout";
import UserLayout from "../../components/layout/UserLayout";
import CustomSettings from "../../components/settings";
import AuthGuard from "../../components/route-guard/AuthGuard";
import { useRouter } from "../../helper-functions/useRouterReplacement";
import SEO from "../../components/seo";
import useConfigData from "../../hooks/useConfigData";
import SplashScreen from "../../splash-screen";

const Index = () => {
    const { configData, landingPageData, loading } = useConfigData();
    const {t} = useTranslation();
    const router = useRouter();

    if (loading) {
        return <SplashScreen />;
    }

    
    
    

    

    return (
        <>
            <CssBaseline/>
            <SEO
                title={configData ? `Settings` : "Loading..."}
                image={`${configData?.base_urls?.business_logo_url}/${configData?.fav_icon}`}
                businessName={configData?.business_name}
            />
            <MainLayout configData={configData} landingPageData={landingPageData}>
                <NoSsr>
                    <AuthGuard from={router.pathname.replace("/", "")}>
                        <UserLayout
                            component={<CustomSettings configData={configData} t={t}/>}
                            configData={configData}
                            t={t}
                        />
                    </AuthGuard>
                </NoSsr>
            </MainLayout>
        </>
    );
};

export default Index;
